import React from "react";
import { useAuth } from "@/lib/AuthContext";
import { Clock, Mail, LogOut, XCircle } from "lucide-react";

export default function PendingApproval() {
  const { user, workspace, logout } = useAuth();
  const rejected = workspace?.approval_status === "rejected";

  return (
    <div className="min-h-screen grid place-items-center px-6" data-testid="pending-approval-screen">
      <div className="max-w-lg w-full border co-hairline bg-white p-8 lg:p-10">
        <div className={`w-14 h-14 grid place-items-center rounded-sm mb-6 ${
          rejected ? "bg-[#FEE2E2] text-[#B91C1C]" : "bg-[#FEF3C7] text-[#B45309]"
        }`}>
          {rejected ? (
            <XCircle className="h-7 w-7" strokeWidth={1.75} />
          ) : (
            <Clock className="h-7 w-7" strokeWidth={1.75} />
          )}
        </div>
        <div className="co-label">
          {rejected ? "Signup rejected" : "Waiting for approval"}
        </div>
        <h1 className="font-heading text-3xl font-bold tracking-tight mt-2">
          {rejected ? "Your workspace was not approved" : "Almost there, hang tight!"}
        </h1>
        <p className="text-sm text-[#52525B] mt-3">
          {rejected ? (
            <>Your workspace <b>{workspace?.name}</b> did not clear the platform review.
              If this looks like a mistake please contact platform support.</>
          ) : (
            <>Your workspace <b>{workspace?.name}</b> was just created and is waiting
              for the CollectOne platform admin to approve. This usually takes a few hours.</>
          )}
        </p>
        <div className="mt-6 border co-hairline bg-[#FAFAFA] p-4 text-xs text-[#52525B] space-y-1">
          <div><span className="co-label mr-2">Owner</span>{user?.name} · {user?.email}</div>
          <div><span className="co-label mr-2">Workspace</span>{workspace?.name}</div>
          <div><span className="co-label mr-2">Type</span>{workspace?.business_type}</div>
        </div>
        <div className="mt-8 flex items-center gap-3">
          <a
            href="mailto:support@collectone.in"
            className="inline-flex items-center gap-2 border co-hairline hover:bg-[#F4F4F5] px-4 py-2 text-sm font-semibold rounded-sm co-btn-press transition-colors duration-200"
          >
            <Mail className="h-4 w-4 text-[#4338CA]" strokeWidth={1.75} />
            Contact support
          </a>
          <button
            type="button"
            onClick={logout}
            data-testid="pending-logout"
            className="inline-flex items-center gap-2 text-sm text-[#52525B] hover:text-[#0A0A0B] px-4 py-2"
          >
            <LogOut className="h-4 w-4" strokeWidth={1.75} />
            Log out
          </button>
        </div>
      </div>
    </div>
  );
}
